if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    /*
      商品画像の拡大表示。Dawn標準は全画像を縦に並べてクリックした画像までスクロールする作りで、
      縦長画像が画面に収まらず拡大表示として機能しなかったため、
      「クリックした画像から1枚ずつ表示し、矢印ボタン・左右キー・スワイプで切り替える」形にしている。
      表示の切り替えは .active クラスで行い、CSSは assets/flex-theme.css の product-media-modal を参照。
    */
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('[role="document"]');
        this.onKeydown = this.onKeydown.bind(this);
        this.buildNavigation();
        this.bindSwipe();
      }

      show(opener) {
        super.show(opener);
        this.items = this.getItems();
        const openedId = this.openedBy.getAttribute('data-media-id');
        const index = this.items.findIndex((item) => item.getAttribute('data-media-id') === openedId);
        this.goTo(index === -1 ? 0 : index);
        document.addEventListener('keydown', this.onKeydown);
      }

      hide() {
        document.removeEventListener('keydown', this.onKeydown);
        super.hide();
      }

      // 「色ごとの画像を隠す」設定のとき、Dawn標準と同じく先頭以外のバリエーション画像は対象外にする
      getItems() {
        const all = Array.from(this.content.querySelectorAll(':scope > [data-media-id]'));
        return all.filter(
          (item, i) => i === 0 || !item.classList.contains('product__media-item--variant')
        );
      }

      goTo(index) {
        const count = this.items.length;
        this.index = (index + count) % count;
        this.items.forEach((item, i) => item.classList.toggle('active', i === this.index));

        // 表示する画像と前後の画像は遅延読み込みを解除して、すぐに読み込む
        [-1, 0, 1].forEach((offset) => {
          const item = this.items[(this.index + offset + count) % count];
          if (item.tagName === 'IMG') item.loading = 'eager';
        });

        // 前の画像で再生中の動画を止めてから、表示する動画（YouTube）を読み込む
        window.pauseAllMedia();
        const active = this.items[this.index];
        const template = active.querySelector('template');
        if (active.nodeName == 'DEFERRED-MEDIA' && template && template.content.querySelector('.js-youtube')) {
          active.loadContent();
        }

        this.counter.textContent = `${this.index + 1} / ${count}`;
        this.classList.toggle('product-media-modal--single', count < 2);
      }

      buildNavigation() {
        const dialog = this.querySelector('[role="dialog"]');
        const makeButton = (direction, label, path) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `product-media-modal__nav product-media-modal__nav--${direction}`;
          button.setAttribute('aria-label', label);
          button.innerHTML = `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${path}"/></svg>`;
          // ModalDialog はマウスの pointerup でモーダルを閉じるため、ボタン上では伝播させない
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', () => this.goTo(this.index + (direction === 'next' ? 1 : -1)));
          dialog.appendChild(button);
        };
        makeButton('prev', '前の画像', 'm15 18-6-6 6-6');
        makeButton('next', '次の画像', 'm9 18 6-6-6-6');

        this.counter = document.createElement('p');
        this.counter.className = 'product-media-modal__counter';
        this.counter.setAttribute('aria-live', 'polite');
        dialog.appendChild(this.counter);
      }

      onKeydown(event) {
        if (!this.hasAttribute('open')) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.index + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.index - 1);
        }
      }

      bindSwipe() {
        let startX = null;
        let startY = null;
        this.content.addEventListener(
          'touchstart',
          (event) => {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );
        this.content.addEventListener('touchend', (event) => {
          if (startX === null) return;
          const dx = event.changedTouches[0].clientX - startX;
          const dy = event.changedTouches[0].clientY - startY;
          startX = null;
          // 横方向に50px以上、かつ縦より横の動きが大きいときだけスワイプとみなす
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
          this.goTo(this.index + (dx < 0 ? 1 : -1));
        });
      }
    }
  );
}
